module.exports = __webpack_public_path__ + "media/images/img-award-b1a84ae1ea2d0128698c7f421efaa1e7.jpg";